import { graphqlRequest } from "../graphqlClient";
import type {
	RecurringTransactionViewConnection,
	RecurringTransactionViewFilterInput,
} from "../models/recurringTransactionView";

export interface RecurringTransactionViewSortInput {
	field: string;
	order: "Ascending" | "Descending";
}

interface RecurringTransactionViewListResponse {
	recurringTransactions: {
		recurringTransactionViewList: RecurringTransactionViewConnection;
	};
}

export async function getRecurringTransactionsGraphql(
	filter?: RecurringTransactionViewFilterInput,
	first?: number,
	after?: string,
	sort?: RecurringTransactionViewSortInput[],
): Promise<RecurringTransactionViewConnection> {
	const query = `
    query RecurringTransactionViewList($filter: RecurringTransactionViewFilterInput, $first: Int, $after: String, $sort: [RecurringTransactionViewSortSortByInput!]) {
      recurringTransactions {
        recurringTransactionViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              name
              direction
              amount
              isVariable
              currency
              category
              counterpartyName
              frequency
              frequencyNumber
              startDate
              endDate
              nextDueDate
              status
              notes
              source
              dataSourceName
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
	const data = await graphqlRequest<RecurringTransactionViewListResponse>(
		query,
		{ filter, first, after, sort },
	);
	return data.recurringTransactions.recurringTransactionViewList;
}

interface RecurringTransactionViewCountResponse {
	recurringTransactions: {
		recurringTransactionViewCount: number;
	};
}

export async function getRecurringTransactionsCount(
	filter?: RecurringTransactionViewFilterInput,
): Promise<number> {
	const query = `
    query RecurringTransactionViewCount($filter: RecurringTransactionViewFilterInput) {
      recurringTransactions {
        recurringTransactionViewCount(filter: $filter)
      }
    }
  `;
	const data = await graphqlRequest<RecurringTransactionViewCountResponse>(
		query,
		{ filter },
	);
	return data.recurringTransactions.recurringTransactionViewCount;
}
